// extracted by mini-css-extract-plugin
export default {"searchIconWrapper":"aOEd7f"};